<template>
  <div>
    <el-upload
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      class="avatar-uploader"
      action="">
      <el-image v-if="imageUrl" :src="imageUrl" class="avatar"
fit="fit"></el-image>
      <i v-else class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
  </div>
</template>
<script>
// TODO change API
// import { uploadToCeph } from '@/api/storeInfo';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      imageUrl: '',
    };
  },
  watch: {
    value: {
      handler(val, oldVal) {
        this.imageUrl = val;
      },
      immediate: true,
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100MB!');
      }
      if (!isJPG || !isLt2M) {
        return false;
      }
      const me = this;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      // eslint-disable-next-line
      reader.onload = function() {
        // 图片大于100K压缩
        if (file.size > 1024 * 0.1) {
          const img = new Image();
          img.src = this.result;
          img.onload = () => {
            const originWidth = img.width;
            const originHeight = img.height;
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = 512; // 压缩后的宽度
            canvas.height = (originHeight * canvas.width) / originWidth;
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            me.handleUpload(canvas.toDataURL('image/jpeg'));
          };
        } else {
          me.handleUpload(this.result);
        }
      };
      return false; // isJPG && isLt2M;
    },
    handleUpload(base64) {
      // base64 = base64.replace(/data\:image\/(png|jpeg);base64,/g, '');
      // uploadToCeph({ base64 }).then((res) => {
      //   const { url } = res.data;
      //   this.imageUrl = url;
      //   this.emitChange(url);
      // });
    },
    emitChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>
<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
